import { useEffect } from 'react';

import { useTaskFrameStore, useToolPermissionStore } from '@/store';

const Prework = () => {
  const { currentFrame, isAssignedMe } = useTaskFrameStore();
  const { setPermission } = useToolPermissionStore();

  useEffect(() => {
    setPermission({
      labeling: {
        readable: true,
        updatable: false,
        acceptable: isAssignedMe(),
      },
      labelingReview: {
        readable: true,
        updatable: false,
        acceptable: false,
      },
      preAnnotation: {
        acceptable: isAssignedMe(),
      },
      aiAssist: {
        acceptable: isAssignedMe(),
      },
    });
  }, [currentFrame?.frameSeq, currentFrame?.workState]);

  return <></>;
};

export default Prework;
